// Copyright (c) 2021 WiseTime. All rights reserved.

import React from "react"
import { useSelector } from "react-redux"
import { Loader } from "../../shared/styles"
import * as TrashedTimeSlice from "../trash/slice"
import { TimelineMonth } from "../dateTime"

type Props = {
  isFuture: boolean,
  timelineMonth: TimelineMonth,
}

const DateTabIndicatorTrash = ({ isFuture, timelineMonth }: Props): React.ReactElement<Props> | null => {
  const trashedRowsRefreshRequired = useSelector(TrashedTimeSlice.selectTrashedRowsRefreshRequired)
  const activeTimelineMonth = useSelector(TrashedTimeSlice.selectActiveTrashMonth)

  if (!isFuture && trashedRowsRefreshRequired && timelineMonth === activeTimelineMonth) {
    return <Loader/>
  }
  return null
}

export default DateTabIndicatorTrash
